import React, { useEffect } from "react";
import useValidation from "../../hooks/useValidation";
import { TaxServiceRegistrationType } from "../../static/types/commonTypes/taxServiceRegistrationType";
import { taxServiceRegistrationSchema } from "../../utils/validation/taxServiceRegistrationValidationSchema";
import { taxServices } from "../../static/types/objectType";

type TaxServiceRegistrationProps = {
    checked: boolean;
    taxServiceOption: string[];
    taxServiceRegistration: TaxServiceRegistrationType;
    updateTaxServiceRegistration: (taxServiceRegistration: TaxServiceRegistrationType) => void;
    onValidationChange: (isValid: boolean) => void;
};

export default function TaxServiceRegistration ({
    checked,
    taxServiceOption,
    taxServiceRegistration,
    updateTaxServiceRegistration,
    onValidationChange,
}: TaxServiceRegistrationProps) {
    const { errors, isValid: isDataValid } = useValidation(taxServiceRegistration, taxServiceRegistrationSchema);

    useEffect(() => {
        onValidationChange(isDataValid);
      }, [isDataValid, onValidationChange]);

    useEffect(() => {
        updateTaxServiceRegistration({
            ...taxServiceRegistration,
            taxService: taxServiceOption[0],
        });
    }, []);

    return (
        <div className="container p-4">
            <div className="row mb-2">
                <label htmlFor="taxService" className="col-3 col-form-label fw-bold mb-1" style={{marginRight: '-100px'}}>
                    Service <span className="text-danger">*</span>
                </label>
                <div className="col-6">
                    <select
                        className={`form-select ${checked && errors.actNature ? "is-invalid" : ""}`}
                        id="taxService"
                        onChange={(event) =>
                        updateTaxServiceRegistration({...taxServiceRegistration, taxService: event.target.value })
                        }
                        value={taxServiceRegistration.taxService}
                    >
                        {taxServices.map((service, index) => (
                        <option key={index} value={service}>
                            {service}
                        </option>
                        ))}
                    </select>
                        {checked && errors.taxService && (
                            <div className="invalid-feedback">{errors.taxService}</div>
                        )}
                </div>
            </div>
            <div className="row mb-2">
                <label htmlFor="taxVille" className="col-3 col-form-label fw-bold mb-1" style={{marginRight: '-100px'}}>
                    Ville <span className="text-danger">*</span>
                </label>
                <div className="col-6">
                    <input
                        className={`form-control ${checked && errors.taxVille? "is-invalid" : ""}`}
                        id="taxVille"
                        type="text"
                        placeholder="Saisissez votre ville"
                        value={taxServiceRegistration.taxVille}
                        onChange={(event) =>
                            updateTaxServiceRegistration({...taxServiceRegistration, taxVille: event.target.value })
                        }
                    />
                </div>
            </div>
        </div>
    );

}